import { SEND_EDIT_PROFESSION } from "../../../constants/ProfessionConstants";

export default function sendEditProfessionAction() {
    return {
        type: SEND_EDIT_PROFESSION
    };
}
